<template>
  <v-content>
    <v-container
      fluid
    >
      <v-row
        class="ma-0"
        align-content="center"
        justify="center"
      >
        <v-btn
          large
          color="primary"
          style="text-transform:none !important"
          @click.stop="doSignOut"
        >
          Log Out
        </v-btn>

        <!-- bottom toolbar -->
        <bottomNavigation
          activeNav="signOut"
        ></bottomNavigation>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import firebase from "firebase/app"
import "firebase/firestore"
import "firebase/auth"
import BottomNavigation from '@/components/Like/BottomNavigation'

export default {
  components: {
    BottomNavigation,
  },
  mounted() {
    // 認証状態の確認。ログインしていないならLike検索へ。
    firebase.auth().onAuthStateChanged((user) => {
      // 直リンクするページはcallbackを使わないと取れない。
      if (!user) {
        this.$router.push('/')
      }
    })
  },
  methods: {
    async doSignOut() {
      try {
        await firebase.auth().signOut()
        this.$router.push('/')
      } catch (e) {
        alert('sign out failed.')
      }
    },
  },
}
</script>
